import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentClear from 'material-ui/svg-icons/content/clear';
import {green500, red500, blue500} from 'material-ui/styles/colors';

class TagEditor extends React.Component {

    constructor(props) {
        super(props);
        this.tagNo1Change = this
            .tagNo1Change
            .bind(this);

        this.tagNo2Change = this
            .tagNo2Change
            .bind(this);

        this.toggleEditing = this
            .toggleEditing
            .bind(this);

        this.resetTags = this
            .resetTags
            .bind(this);

        this.onSave = this
            .onSave
            .bind(this);

    }

    componentWillReceiveProps(){

    }

    resetTags(e) {
        e.preventDefault();
        const {onChange, orderId, setTagEditing, networkDetails} = this.props;
        onChange({
            action: 'reset'
        }, orderId);

        const isEditing = networkDetails.get('tagEditing');

        setTagEditing(!isEditing, orderId);
    }

    toggleEditing(e) {
        e.preventDefault();
        const {networkDetails, setTagEditing, orderId} = this.props;

        const isEditing = networkDetails.get('tagEditing');

        setTagEditing(!isEditing, orderId);
    }

    tagNo1Change(e) {
        const {onChange, orderId, networkDetails} = this.props;
        onChange({
            tagNo1: e.target.value,
            tagNo2: networkDetails.get('tagNo2') ? networkDetails.get('tagNo2') : ' '
        }, orderId);

    }

    tagNo2Change(e) {
        const {onChange, orderId, networkDetails} = this.props;
        onChange({
            tagNo2: e.target.value,
            tagNo1: networkDetails.get('tagNo1') ? networkDetails.get('tagNo1') : ' '
        }, orderId);

    }
    onSave(e) {
        e.preventDefault();
        const {
            onSave,
            orderId,
            houseNumber,
            networkDetails,
            billingSystem,
            accountNumber
        } = this.props;

        onSave({
            houseNumber: houseNumber,
            billingSystem: billingSystem,
            accountNumber: accountNumber,
            tag1: networkDetails.get('tagNo1'),
            tag2: networkDetails.get('tagNo2')
        }, orderId);

    }

    render() {

        const {networkDetails} = this.props;

        if (!networkDetails) {
            return null;
        }
        const isEditing = networkDetails.get('tagEditing');

        let tagNo1 = networkDetails.get('tagNo1'),
            tagNo2 = networkDetails.get('tagNo2');
        const tagUpdateStarted = networkDetails.get('tagUpdateStarted'),
            tagUpdateMessage = (
                <span style={{
                    color: green500
                }}>{networkDetails.get('tagUpdateMessage')}</span>
            ),
            tagUpdateError = (
                <span style={{
                    color: red500
                }}>{networkDetails.get('tagUpdateError')}</span>
            );

        if (tagNo1) {
            tagNo1 = tagNo1.trim();
        }
        if (tagNo2) {
            tagNo2 = tagNo2.trim();
        }

        let tagNo1Output = null,
            tagNo2Output = null,
            actionButton = null,
            resetButton = null,
            tagLoadingMessage = null;

        const buttonStyle = {
            padding: '0',
            width: '36px',
            height: '36px'
        };

        if (!isEditing) {
            tagNo1Output = tagNo1 || 'N/A';
            tagNo2Output = tagNo2 || 'N/A';
            actionButton = (
                <IconButton style={buttonStyle} onClick={this.toggleEditing}>
                    <ContentCreate/>
                </IconButton>
            );
        } else {
            tagNo1Output = (<TextField
                id="tagno1"
                style={{
                width: '90%'
            }}
                value={tagNo1 || ''}
                onChange={this.tagNo1Change}/>);
            tagNo2Output = (<TextField
                id="tagno2"
                style={{
                width: '90%'
            }}
                value={tagNo2 || ''}
                onChange={this.tagNo2Change}/>);
            resetButton = (
                <IconButton
                    style={buttonStyle}
                    iconStyle={{
                    color: red500
                }}
                    onClick={this.resetTags}>

                    <ContentClear/>
                </IconButton>
            );
            actionButton = (
                <IconButton
                    style={buttonStyle}
                    iconStyle={{
                    color: green500
                }}
                    onClick={this.onSave}>

                    <ContentSave/>
                </IconButton>
            );

        }

        if (tagUpdateStarted) {
            tagLoadingMessage = (
                <span style={{
                    color: blue500
                }}>Updating tags...</span>
            );
            actionButton = null;
            resetButton = null;
        }

        return (
            <div style={{
                paddingTop: '3px'
            }}>

                <div style={{
                    paddingLeft: '8px'
                }}>
                    {tagLoadingMessage}
                    {tagUpdateMessage}
                    {tagUpdateError}
                </div>
                <div className="row wow-fst-input-container">

                    <div
                        className="col s2 m2 l2"
                        style={{
                        paddingRight: '0px'
                    }}>
                        {actionButton}
                        {resetButton}
                    </div>

                    <div
                        className="col s5 m5 l5"
                        style={{
                        paddingLeft: '0px',
                        paddingRight: '0px'
                    }}>
                        <label
                            style={{
                            paddingRight: '3px'
                        }}>Account Tag:
                        </label><br/> {tagNo1Output}
                    </div>
                    <div
                        className="col s5 m5 l5"
                        style={{
                        paddingLeft: '0px',
                        paddingRight: '0px'
                    }}>

                        <label
                            style={{
                            paddingRight: '3px'
                        }}>Address Tag:
                        </label><br/> {tagNo2Output}
                    </div>

                </div>
            </div>

        );
    }

}

TagEditor.propTypes = {
    orderId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    houseNumber: PropTypes.string,
    networkDetails: PropTypes.object,
    setTagEditing: PropTypes.func,
    accountNumber: PropTypes.string,
    billingSystem: PropTypes.string
};

export default TagEditor;


// WEBPACK FOOTER //
// ./src/components/work-order/TagEditor.js